import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import KsoftDocumentsTable from "../../components/Tables/KsoftDocumentsTable";
import Swal from "sweetalert2";
import {apiCall} from "../../helpers/MainHelper";

class Documents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      isLoad:false,
    }
  }
  queryDocument = async (e) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: 'Gelen kutusu sorgulanıyor...',
        text: 'Lütfen bekleyin, işleminiz devam ediyor.',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        }
      });
      const response = await apiCall(`business/ksoft/query-document`, 'get', null);

      Swal.close();
      Swal.fire({
        title: 'Gelen Kutusu Sorgulama',
        text:response.message,
        icon: response.status,
        confirmButtonText: 'Tamam'
      });
      if (response.status === 'success'){
        window.location.reload();
      }
    } catch (error) {
      Swal.close();
      Swal.fire({
        title: 'Gelen Kutusu Sorgulama',
        text:'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz!',
        icon: 'error',
        confirmButtonText: 'Tamam'
      });
      console.error(error);

    }

  }
  render() {

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Fatura Gelen Kutusu"
                Breadcrumb={[
                  {name: "Faturalar", navigate: ""},
                  {name: "Fatura Gelen Kutusu", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="header text-right">
                    <button onClick={this.queryDocument} className="btn btn-outline-secondary"><i className="fa fa-refresh"></i> Gelen Kutusunu Güncelle</button>
                  </div>
                  <div className="body">
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                        <KsoftDocumentsTable></KsoftDocumentsTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({analyticalReducer}) => ({});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Documents)));
